import {
  IconExpandMoreMS,
  IconKeyboardArrowRightMS,
} from '../../../../../../../../../../constants/icons';
import { AccordionCriteriaTitle } from './styles';

interface AccordionTitleProps {
  title: string;
  openAccordion: boolean;
  setOpenAccordion: (accordion: boolean) => void;
}

export function AccordionCriteria({
  title,
  openAccordion,
  setOpenAccordion,
}: AccordionTitleProps): JSX.Element {
  return (
    <AccordionCriteriaTitle
      onClick={() => {
        setOpenAccordion(!openAccordion);
      }}
    >
      {title}
      {openAccordion ? IconExpandMoreMS : IconKeyboardArrowRightMS}
    </AccordionCriteriaTitle>
  );
}
